export default "__VITE_ASSET__B83ibjLz__"